import { defineMessages } from 'react-intl';

const messages = defineMessages({
  searchButtonText: {
    id: 'pgn.SearchField.searchButton',
    defaultMessage: 'Search',
    description: 'Accessible default text for the search submit button',
  },
});

export default messages;
